import axios from '../../../axios';
import { IWorkspace } from '../../WorkspaceService';

export const getJobAttr = () => axios.get('api/workspace/job-attribute-settings');
export const updateJobAttr = (payload: IWorkspace) => axios.put('api/workspace', payload);
